"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var pulse = (0, _styledComponents.keyframes)(["0%{-moz-box-shadow:0 0 0 0 rgba(36,164,127,0.4);box-shadow:0 0 0 0 rgba(36,164,127,0.4);}70%{-moz-box-shadow:0 0 0 10px rgba(36,164,127,0);box-shadow:0 0 0 10px rgba(36,164,127,0);}100%{-moz-box-shadow:0 0 0 0 rgba(36,164,127,0);box-shadow:0 0 0 0 rgba(36,164,127,0);}"]);
var PulseAnimation = (0, _styledComponents.css)(["animation:", " 1s infinite;"], pulse);
var _default = exports["default"] = PulseAnimation;